export const ApplicationInfo = {
  ciJobId : '53569622',
  ciJobUrl : 'https://gitlab.ihsmarkit.com/brs/github-latest/research-manager-admin-portal/-/jobs/53569622',
  ciPipeLineId : '10073302',
  ciPipelineUrl : 'https://gitlab.ihsmarkit.com/brs/github-latest/research-manager-admin-portal/-/pipelines/10073302',
  ciCommitRefName : 'release/2026_01_16',
  projectVersion : ''
};
